import { useTranslation } from "react-i18next";
import { Input } from "../ui/input";
import { useScheduleStore } from "../../stores/schedule-store";
import { dispatchScheduleEvent, endHistoryMerge } from "../../lib/schedule-history/dispatch";

export function CommonOptionsSection() {
  const memberOnlyLabel = useScheduleStore(state => state.commonOptions.memberOnlyLabel);
  return <CommonOptionsForm memberOnlyLabel={memberOnlyLabel}
    onChange={value => dispatchScheduleEvent({ type: "common/set", patch: { memberOnlyLabel: value } }, "common:memberOnlyLabel")} onBlur={endHistoryMerge} />;
}

type CommonOptionsFormProps = { memberOnlyLabel?: string; onChange: (value: string) => void; onBlur?: () => void; };

export function CommonOptionsForm({ memberOnlyLabel, onChange, onBlur }: CommonOptionsFormProps) {
  const { t } = useTranslation();

  return (
    <section className="space-y-3 border-t border-neutral-200 pt-4">
      <h3 className="text-xs font-semibold text-neutral-900">{t("schedule.commonOptions")}</h3>
      <label className="grid gap-1.5 text-xs text-neutral-600">
        {t("schedule.memberOnlyLabel")}
        <Input
          className="h-8 rounded bg-white text-xs shadow-none"
          value={memberOnlyLabel ?? t("schedule.memberOnly")}
          onChange={event => onChange(event.target.value)}
          onBlur={onBlur}
        />
      </label>
    </section>
  );
}
